import { bg1, bg2, bg3, bg4 } from './bg';
import assets from './icon/asset_hover.svg';
import assets_gray from './icon/asset_normal.svg';
import insight from './icon/insight_hover.svg';
import insight_gray from './icon/insight_normal.svg';
import safety from './icon/safety_hover.svg';
import safety_gray from './icon/safety_normal.svg';
import tags from './icon/tags_hover.svg';
import tags_gray from './icon/tags_normal.svg';

export const switchList = [
    {
        title: '资产管理',
        icon: assets,
        hover: assets_gray,
    },
    {
        title: '丰富的标签体系',
        icon: tags,
        hover: tags_gray,
    },
    {
        title: '洞察与价值分析',
        icon: insight,
        hover: insight_gray,
    },
    {
        title: '安全与性能',
        icon: safety,
        hover: safety_gray,
    },
];

export const assetsManage = [
    {
        title: '定制生态资产管理',
        desc: '实现客户人群与数据资产在快手不同平台、账户间便捷流通，高效投放。',
    },
    {
        title: '沉淀自有数据',
        desc: '以自有数据为基础，实现在平台新的增长机遇。',
    },
];

export const tagsSystem = [
    {
        title: '多维标签体系',
        desc: '集成快手平台内容与大数据，提供多维度通用和基础标签数据服务。',
    },
    {
        title: '高阶定制人群',
        desc: '专属定制、主题专区资产结合，满足客户多元化探索用户诉求，助力客户精准定目标人群。',
    },
    {
        title: '合作标签',
        desc: '多数据源整合，打造全面、立体的标签体系，助力客户精准的多元营销。',
    },
    {
        title: '智能推荐算法',
        desc: '基于历史投放与核心人群，定位目标人群与优质人群推荐，扩大品牌受众。',
    },
];

export const valueAnalysis = [
    {
        title: '全方位的用户洞察',
        desc: '依托海量数据，全面、准确的探索用户的深度诉求。',
    },
    {
        title: '全链路人群价值分析',
        desc: '呈现用户行动轨迹与转化链路，助力企业营销决策，实现投前投中投后闭环。',
    },
];

export const securityPerformance = [
    {
        title: '安全保障严格',
        desc: '单独的数据存储空间，严谨的人群授权体系，为客户数据安全和投放保驾护航。',
    },
    {
        title: '性能强大',
        desc: '大容量数据存储空间与高性能的数据计算能力，助力营销增长。',
    },
];

export const cardList = [assetsManage, tagsSystem, valueAnalysis, securityPerformance];
export const bgList: React.FC[] = [bg1, bg2, bg3, bg4];
